import asyncFetch from './async-fetch';
import { getBaseRequestConfig } from './baseRequestConfig';

export async function fetchDropboxLogs(dropboxId, criteria) {
    /* global API_BASE_URL */
    let url = `${API_BASE_URL}/dropboxes/${dropboxId}/logs?`;
    url = criteria.assignment ? `${url}&assignment=${criteria.assignment}`: url;
    url = criteria.precept ? `${url}&precept=${criteria.precept}`: url;
    url = criteria.user ? `${url}&user=${criteria.user}`: url;
    url = criteria.from ? `${url}&from=${criteria.from}`: url;
    url = criteria.to ? `${url}&to=${criteria.to}`: url;
    url = criteria.ip_address ? `${url}&ip_address=${criteria.ip_address}`: url;
    url = criteria.uri ? `${url}&uri=${encodeURIComponent(criteria.uri)}`: url;
    url = criteria.referer ? `${url}&referer=${encodeURIComponent(criteria.referer)}`: url;
    url = criteria.val ? `${url}&val=${encodeURIComponent(criteria.val)}`: url;
    url = criteria.method ? `${url}&method=${encodeURIComponent(criteria.method)}`: url;
    url = criteria.event ? `${url}&event=${encodeURIComponent(criteria.event)}`: url;
    url = criteria.role ? `${url}&role=${encodeURIComponent(criteria.role)}`: url;
    url = criteria.offset !== undefined ? `${url}&offset=${criteria.offset}`: url;
    url = criteria.limit !== undefined ? `${url}&limit=${criteria.limit}`: url;
    url = criteria.sortField ? `${url}&sortField=${criteria.sortField}`: url;
    url = criteria.sort ? `${url}&sort=${criteria.sort}`: url;

    const baseRequestConfig = getBaseRequestConfig();

    const response = await asyncFetch(url, baseRequestConfig);

    return await response.json();
}



/** WEBPACK FOOTER **
 ** ./src/connectivity/api.logs.js
 **/